import { Component, ViewChild } from '@angular/core';
import { ActiveUser } from '@core/models/dashboard.model';
import { TranslocoService } from '@ngneat/transloco';
import { Column, createColumn, EnhancedTable } from 'src/app/modules/enhanced-table';

import { createQuery, IQuery } from '../../../../../utils/query';
import { Refreshable } from '../../../../../utils/refreshable.interface';
import { DashboardService } from '../../dashboard.service';
import it from './i18n/active-users.it.json';

@Component({
  selector: 'app-active-users',
  templateUrl: './active-users.component.html'
})
export class ActiveUsersComponent implements Refreshable {

  @ViewChild('table') table!: EnhancedTable<ActiveUser>;

  sourceFn = (query: IQuery) => this.dashboardSvc.getActiveUsers(query);
  columns: Column<ActiveUser>[];

  constructor(private dashboardSvc: DashboardService,
    private translocoSvc: TranslocoService,
  ) {
    this.translocoSvc.setTranslation(it, 'it');

    this.columns = [
      createColumn({ label: this.translocoSvc.translate('activeUsers.fields.userFullname'), field: 'userFullname' }),
      createColumn({ label: this.translocoSvc.translate('activeUsers.fields.sessionsCount'), field: 'sessionsCount' }),
      createColumn({ label: this.translocoSvc.translate('activeUsers.fields.lastLoginAt'), field: 'lastLoginAt', type: 'utcDatetime' })
    ];
  }

  refresh() {
    this.table.fetch(createQuery({ index: 0 }));
  }

}
